import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Buttons from "./Buttons";
import Logo from "../assets/image/Logo_TransparentBG.png";

const Header = () => {
  return (
    <div className="flex justify-between items-center">
      {/* <img src="" alt="" /> */}
      <div className="flex items-center h-20 px-7 text-[#221A1A] text-lg font-Outfit font-bold tracking-[5.4px] break-words">
        <Link to="/"><img src={Logo} className="w-logoWidth" /></Link>
      </div>
      {/* <Navbar /> */}
      <Buttons />
    </div>
  );
};

export default Header;
